import React, { useState, useEffect } from 'react';
import PropTypes, { object } from 'prop-types';

import {
  PageSubTitle,
  Loading,
  RadioButton
} from 'components/common/Elements/Elements';
import { ColumnNew } from 'components/common/charts/charts';
import { Legend } from 'components/common/charts/parts/parts';

import {
  monthesPeriods,
  monthPerLabel
} from 'components/common/charts/helpers/config/filtersConfig';
import useWindowSize from 'hooks/useWindowSize';
import { scoreOverTimeConfig } from '../../../helpers/configurates';

import classes from './ResponseOverTime.module.scss';

const ResponseOverTime = ({ data, loader }) => {
  const [period, setPeriod] = useState('6M');
  const [conf, setConf] = useState(scoreOverTimeConfig);

  const [show, setShow] = useState(true);
  const [oldSize, setOldSize] = useState(0);

  const size = useWindowSize();
  const length = data.length;

  useEffect(() => {
    let timer = null;
    if (oldSize > size.width || (size.width >= 1441 && oldSize < 1441)) {
      setShow(false);
      setOldSize(size.width);
      timer = setTimeout(() => setShow(true), 500);
    } else setOldSize(size.width);
    return () => clearTimeout(timer);
    // eslint-disable-next-line
  }, [size.width]);

  const toCut = () => {
    //lengs of period
    if (period === '6M') {
      return 6;
    } else if (period === '3M') {
      return 3;
    } else {
      return 2;
    }
  };

  const formatDate = //cut date with get period
    period !== '1Y' ? data.slice(Math.max(length - toCut(), 0)) : [...data];

  const handlePeriod = e => {
    if (e.target.value !== period) {
      setPeriod(e.target.value);
    }
  };

  if (!loader) {
    return <Loading />;
  }

  return (
    <section className={classes.box}>
      <div className={classes.info}>
        <PageSubTitle
          title="CSAT Score/Rating over time chart"
          size={3}
          weight="b"
          className={classes.header}
        />
        <RadioButton
          handleUnit={handlePeriod}
          unit={period}
          units={monthesPeriods}
          name="Period"
          type="c"
          unitsLabel={monthPerLabel}
        />
      </div>
      {show ? <ColumnNew data={formatDate} config={conf} /> : <Loading />}
      <Legend config={conf} setConfig={setConf} />
    </section>
  );
};

ResponseOverTime.propTypes = {
  data: PropTypes.arrayOf(object),
  loader: PropTypes.bool
};

export default ResponseOverTime;
